import {
  Avatar, Flexbox, Form, ListManager, Paginator, QuickFilter,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import useQuery from '@/hooks/useQuery'
import animals from '@/services/api/animals'
import React, { useState } from 'react'
import FormComplete from '../FormComplete'

export default function MyAnimals() {
  const [animal, setAnimal] = useState(null)
  const query = useQuery()

  const { data, error, loading } = useAxiosRequest(
    animals.partnerAnimals, { ...(query || {}), take: 5 },
  )

  if (animal) return <FormComplete animal={animal} onCancel={() => setAnimal(null)} />

  return (
    <div className="mt-2">
      <QuickFilter
        initialValues={{ name_cont: '' }}
        title="Filtrar meus pets"
        renderForm={() => (
          <Flexbox.Column className="pt-2">
            <Form.Group>
              <Form.Label className="label-sm pt-2" htmlFor="name_cont">Nome do pet</Form.Label>
              <Form.ValidationField
                name="name_cont"
                className="input-sm"
                id="name_cont"
                autoComplete="none"
                placeholder="Totó da Silva"
              />
            </Form.Group>
          </Flexbox.Column>
        )}
      />
      <ListManager loading={loading} count={data?.count || 0} error={error}>
        {
          Boolean(data) && (
            <div>
              <small>
                <table className="table">
                  <thead>
                    <tr>
                      <th>Pet</th>
                      <th width="1">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data.rows.map((row) => (
                        <tr key={row.id}>
                          <td>
                            <div>
                              <Avatar
                                avatarSize="sm"
                                className="mr-1"
                                name={row?.name}
                                photoURL={row?.photoURL}
                                alt="Imagem do pet"
                              />
                              {row?.name}
                            </div>
                            <div>
                              <small>
                                {row.category.description} - {row.breed.description}
                              </small>
                            </div>
                          </td>
                          <td className="text-right">
                            <a
                              onClick={() => setAnimal(row)}
                              disabled={row === row.id}
                              className={`btn btn-action btn-primary btn-sm ${row === row.id ? 'loading' : ''}`}
                            >
                              <i className="fas fa-check" />
                            </a>
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </small>
              <Paginator paginatedList={data} />
            </div>
          )
        }
      </ListManager>
    </div>
  )
}
